import { render, staticRenderFns } from "./OneYearPromotionPayment.vue?vue&type=template&id=5f545781&scoped=true"
import script from "./OneYearPromotionPayment.vue?vue&type=script&lang=js"
export * from "./OneYearPromotionPayment.vue?vue&type=script&lang=js"
import style0 from "./OneYearPromotionPayment.vue?vue&type=style&index=0&id=5f545781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f545781",
  null
  
)

export default component.exports